import Loader from '@jetbrains/ring-ui-built/components/loader/loader'
import { Text } from '@qodana/blocks/lib/components/Typography'

import styles from './PreparingAppLoader.module.css'

export const PreparingAppLoader = () => {
	return (
		<div className={styles.container}>
			<Loader squares />
			<Text>
				Qodana is getting ready...
				<br />
				Give us a few seconds to load the application.
			</Text>
		</div>
	)
}
